/**
* Carousel Slick
* @type {Boolean}
*/
$('.cases-slick').slick({
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 10000,
  mobileFirst: true
});



//////////////////
// WEBPACK FOOTER
// ./src/javascripts/config.slick.js
// module id = 21
// module chunks = 0